import type { FaireProductEntity } from "../../entity_types/product";

export const p_6ex2trj4kg: FaireProductEntity = {
  token: "p_6ex2trj4kg",
  type: "product",
  name: "Matches in Tin - Ace of Hearts",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/bd3ad065410780074eeb9f02540b486a1909cd69b1034ddb7d0052350905c593.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f4fb101ce5a3f501b08a31573f9893b18dcfe9f9d3f94d51f464977a7dc6d2a.jpeg",
  ],
  priceDollars: 8.5,
  description:
    'These Ace of Hearts Safety Matches are housed in a reusable sliding lid tin featuring a minimalist playing card design inspired by vintage card decks and traditional gaming ephemera. Simple yet striking, the iconic heart motif brings a playful, nostalgic touch to everyday rituals and decorative spaces alike.\n\nContaining 100 safety matches, each tin features striker paper housed within a custom brass holder on the side, combining everyday practicality with timeless design. The sliding lid construction adds a tactile vintage feel, while the reusable tin is designed to be refilled and enjoyed long after the matches are gone. A stylish addition to coffee tables, shelves, and bedside spaces, it also makes a thoughtful gift for game lovers, card players, and admirers of classic graphic design.\n\nContains 100 safety matches. Keep away from children, heat, sparks, and open flames. Store in a dry place.\n\nSize: 12cm H x 8.5cm W x 2.5cm D | 4.72" H x 3.35" W x 0.89" D',
  tags: [],
  msrpDollars: 19,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:34.998Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
